"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _ = require("../..");

var css = _interopRequireWildcard(require("./ConditionalOrder.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * ConditionalOrder implements different UIs for Conditional order flow.
 *
 * A conditional order is an order that remains active for defined days until the specified condition is met or is cancelled.
 * So anytime the condition within this period is met, the order will be executed.
 *
 * A conditional order might include one or more specified criteria which acts a triggering point.
 * This helps the user in bringing more variation to his order placement journey which further save the time and effort of the users.
 *
 * When a `ref` prop is provided, it will be forwarded to the root element.
 */
const ConditionalOrder = /*#__PURE__*/React.forwardRef(({
  scripName,
  scripDate,
  exchange,
  price,
  stoplossValue,
  targetValue,
  productType,
  amount,
  qty,
  side,
  priceConditionType,
  stoplossConditionType,
  targetConditionType,
  isActive = false,
  showAdvancedSettings = true,
  ...otherProps
}, ref) => (0, _pragma.createFelaElement)(_.View, _extends({
  ref: ref,
  css: css.container,
  flexDirection: "column",
  padding: "medium",
  cssProps: {
    isActive
  },
  flex: true
}, otherProps), (0, _pragma.createFelaElement)(_.View, {
  justifyContent: "space-between"
}, (0, _pragma.createFelaElement)(_.ScripCellName, {
  scripName: scripName,
  exchange: exchange,
  scripDate: scripDate
}), (0, _pragma.createFelaElement)(_.View, {
  flexDirection: "column",
  alignItems: "flex-end",
  justifyContent: "space-around"
}, (0, _pragma.createFelaElement)(_.Text, {
  color: "text.2",
  lineHeight: "xs",
  size: "s"
}, productType), (0, _pragma.createFelaElement)(_.Text, {
  color: "text.2",
  lineHeight: "xs",
  size: "s"
}, "".concat(qty, " Qty")))), (0, _pragma.createFelaElement)(_.View, {
  css: css.itemsWrapper
}, (0, _pragma.createFelaElement)(_.ConditionalOrderItem, {
  side: side,
  value: price !== null && price !== void 0 ? price : null,
  conditionType: priceConditionType || null,
  amount: amount,
  qty: qty,
  margin: ['xxxsmall', 0, 'small', 0]
}), showAdvancedSettings ? (0, _pragma.createFelaElement)(React.Fragment, null, (0, _pragma.createFelaElement)(_.ConditionalOrderItem, {
  value: stoplossValue || null,
  conditionType: stoplossConditionType || null,
  side: side === 'Sell' ? 'Buy' : 'Sell',
  margin: [0, 0, 'small', 'medium']
}), (0, _pragma.createFelaElement)(_.ConditionalOrderItem, {
  value: targetValue || null,
  conditionType: targetConditionType || null,
  side: side === 'Sell' ? 'Buy' : 'Sell',
  margin: [0, 0, 0, 'medium']
}), (0, _pragma.createFelaElement)(_.View, {
  css: css.linesWrapper
}, (0, _pragma.createFelaElement)(_.View, null), (0, _pragma.createFelaElement)(_.View, null))) : null)));
ConditionalOrder.displayName = 'ConditionalOrder';
var _default = ConditionalOrder;
exports.default = _default;
//# sourceMappingURL=ConditionalOrder.js.map